import React, { useEffect } from "react";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import {
  temporaryPasswordReducer,
  mapDispatchToProps,
  mapStateToProps,
} from "./TemporaryPassword.store";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";
import TemporaryPassword from "../../library/TemporaryPassword/TemporaryPassword";

export const SmartTemporaryPassword = (props) => {
  const {
    userId,
    username,
    onClose,
    temporaryPassword,
    expiresIn,
    generateTemporaryPassword,
    clearTemporaryPassword,
    unlocking,
    unblocking,
  } = props;

  useEffect(() => {
    return () => clearTemporaryPassword();
  }, [clearTemporaryPassword]);

  useEffect(() => {
    if (userId) {
      generateTemporaryPassword(userId).catch((error) => {
        sendNotification(error, ToastType.ERROR);
      });
    }
  }, [userId, generateTemporaryPassword]);

  return (
    <TemporaryPassword
      onClose={onClose}
      tempPassword={temporaryPassword}
      expiresIn={expiresIn}
      ugnxId={username}
      unlocking={unlocking}
      unblocking={unblocking}
    />
  );
};

export default dynamic(
  "temporaryPasswordReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state, rootState) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(temporaryPasswordReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartTemporaryPassword));
